import request from '@/utils/request'

//getShipNoList
export function getShipNoList(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa013/getShipNoList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//getBlockList
export function getBlockList(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa013/getBlockList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}


//getBlockList
export function getBlockList2(param) {
    let data = param
    return request({
      url: `/outsoucingBlockControl/epmsa013/getBlockList2`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
  }

//getDlyNoList
export function getDlyNoList(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa013/getDlyNoList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//getReqNoList
export function getReqNoList(param) {
    let data = param
    return request({
      url: `/outsoucingBlockControl/epmsa013/getReqNoList`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
  }

//epmsa013detail
export function epmsa013detail(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa013/epmsa013detail`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//epmsa013
export function epmsa013(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa013/epmsa013`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//epmsa010DelyNo
export function epmsa013DelyNo() {
  let data = ''
  return request({
    url: `/outsoucingBlockControl/epmsa013/epmsa013DelyNo`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//epmsa010saveKl
export function epmsa013save(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa013/epmsa013save`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//epmsa010deleteKl
export function epmsa013delete(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa013/epmsa013delete`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}


//epmsa012klxls
export function epmsa013xls(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa013/epmsa013xls`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  }).then(res => {

    const binaryString = window.atob(res.body)
    const binaryLen = binaryString.length
    let bytes = new Uint8Array(binaryLen)
    
    for (let i = 0; i < binaryLen; i++) {
      let ascii = binaryString.charCodeAt(i)
      bytes[i] = ascii
    }
    
    const blob = new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
    const blobURL = URL.createObjectURL(blob)

    const link = document.createElement('a');
    link.href = blobURL;
    link.download = `Steel Assy Delivery Note.xls`;

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  })
}